/* ============
 * Mutation types for the Project module
 * ============
 *
 * The mutation types that are available
 * on the project module.
 */

export const SET_OPT_OUT = 'SET_OPT_OUT';
export const SET_MOBILE_PORTRAIT = 'setMobilePortrait';
export const SET_TOP_MENU = 'setAppBar';

export default {
  SET_OPT_OUT,
  SET_MOBILE_PORTRAIT,
  SET_TOP_MENU,
};
